import { Routes } from '@angular/router';
import { Error404 } from './shared/pages/error404/error404';
import { Logout } from './shared/pages/logout/logout';
import { Login } from './shared/pages/login/login';

export const routes: Routes = [
    { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
    {
      path: 'dashboard',
      loadChildren: () => import('./dashboard/dashboard.routes').then(m => m.DASHBOARD_ROUTES)
    },
    { path: 'auth', component: Login },
    { path: 'logout', component: Logout },
    { path: 'error404', component: Error404 },
    { path: '**', redirectTo: 'error404' },
];
